export const BogoEvents = {
  EVENTS: {
    HOLIDAY_PAGE_CLICK: 'Holiday Page Click',
  },
}

export const BOGO_PROPS = {
  PROMO_BANNER: {
    LOCATION: 'promotion-banner',
  },
  PROMO_MODAL: {
    LOCATION: 'promotion-modal',
    MODAL_TYPE: 'seasonal_promotion',
    ACTIONS: {
      CLOSE: 'close',
    },
  },
  SHARE_MEMBERSHIP: {
    LOCATION: 'post_purchase_bogo_schedule_membership_sharing',
    MODAL_TYPE: 'bogo_schedule_membership_sharing',
  },
  SHARE_DETAILS: {
    LOCATION: 'post_purchase_bogo_add_sharing_details',
    MODAL_TYPE: 'bogo_add_sharing_details',
    MODAL_TYPE_ERROR: 'bogo_add_sharing_details_error',
  },
  OFFER_PAGE: {
    LOCATION: {
      HERO: 'hero',
      INSTRUCTOR_GRID: 'instructor_grid',
      BOGO_EXPLAINER: 'bogo_explainer',
      PRESS_QUOTE_MODULE: 'press_quote_module',
      CATEGORY_EXPLORATION: 'category-exploration',
      LAST_SECTION: 'last_section',
      HOLIDAY_PAGE_PROMOTION_BANNER: 'holiday-page-promotion-banner',
    },
  },
}
